__turbopack_context__.v({
  "colorDot": "_9djiq_colorDot",
  "colorDot--glow": "_9djiq_colorDot--glow",
  "colorDot--lg": "_9djiq_colorDot--lg",
  "colorDot--md": "_9djiq_colorDot--md",
  "colorDot--sm": "_9djiq_colorDot--sm",
});
